import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { UsersService, AuthService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-register-dialog-mail-view',
  templateUrl: './register-dialog-mail-view.component.html',
  styleUrls: ['./register-dialog-mail-view.component.css']
})
export class RegisterDialogMailViewComponent implements OnInit {

  constructor(
    private router: Router,
    public authservice: AuthService,
    public usersservice: UsersService,
    public afAuth: AngularFireAuth,
    public dialogRef: MatDialogRef<RegisterDialogMailViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
    onNoClick(): void {
      this.dialogRef.close();
    }
    register(email, password) {
      const em = email;
      const pa = password;

      this.authservice.signup(em, pa).then(value => {
        const credential = firebase.auth.EmailAuthProvider.credential(email, password);
        const fu = this.authservice.usr.subscribe(usr => {
this.router.navigate(['/contatti','details', usr.uid]);

    });
        this.dialogRef.close();
      }

      ).then(b => {
        const aa = b;
      });
    }
  ngOnInit() {
  }

}
